module.exports = __webpack_public_path__ + "static/img/login_admin.a3768e82.png";